module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2019 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published 2019")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("28 27 26 25 24 23 22 21 20 19    1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("ISBN-13: 978-0-226-49344-2 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-49358-9 (paper)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-49361-9 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("DOI: "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226493619.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226493619.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Figures on pages "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0007#figpg13"
    }
  }, [_vm._v("13")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0007#figpg18"
    }
  }, [_vm._v("18")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0008#figpg27"
    }
  }, [_vm._v("27")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0009#figpg35"
    }
  }, [_vm._v("35")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0009#figpg37"
    }
  }, [_vm._v("37")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0009#figpg46"
    }
  }, [_vm._v("46")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0010#figpg56"
    }
  }, [_vm._v("56")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0010#figpg61"
    }
  }, [_vm._v("61")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0011#figpg66"
    }
  }, [_vm._v("66")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0011#figpg70"
    }
  }, [_vm._v("70")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0012#figpg79"
    }
  }, [_vm._v("79")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0015#figpg113"
    }
  }, [_vm._v("113")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0016#figpg131"
    }
  }, [_vm._v("131")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0016#figpg137"
    }
  }, [_vm._v("137")]), _vm._v(", and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0018#figpg152"
    }
  }, [_vm._v("152")]), _vm._v(" by Maria Celis; Figures on pages "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0012#figpg85"
    }
  }, [_vm._v("85")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0013#figpg91"
    }
  }, [_vm._v("91")]), _vm._v(" by Stefano Bloch; Figure on page "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0017#figpg141"
    }
  }, [_vm._v("141")]), _vm._v(" by Chaz Bojórquez (from "), _c('i', [_vm._v("One Hundred Tags")]), _vm._v(" © Chaz Bojórquez, 1996); Figure on page "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibloch0017#figpg147"
    }
  }, [_vm._v("147")]), _vm._v(" by Christian Guzmán.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Names: Bloch, Stefano, author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: Going all city : struggle and survival in LA’s graffiti subculture / Stefano Bloch.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago : The University of Chicago Press, 2019. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN 2019023567 | ISBN 9780226493442 (cloth) | ISBN 9780226493589 (paperback) | ISBN 9780226493619 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCSH: Graffiti—Social aspects—California—Los Angeles. | Graffiti artists—California—Los Angeles. | Subculture—California—Los Angeles.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC GT3913.C22 L67 2019 | DDC 306.109794/94—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2019023567",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2019023567")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/infinity-symbol.jpg",
      "width": "12"
    }
  }), _vm._v(" This paper meets the requirements of ANSI/NISO Z39.48-1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9592d794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-bloch-0004.vue
// module id = 63
// module chunks = 0